import React from 'react';

const NoPageFound = () => (
  <>
    <h1>No Page Found</h1>
  </>
);

export default NoPageFound;
